(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name manageFlight.service:ManageFlightService
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .service('ManageFlightService', ManageFlightService);

    function ManageFlightService(rx, RemoteService, MessageService, ManageFlightsRequestFactory, ManageFlightsAdaptorFactory) {

        var self = this;
        self.data = {
            airports: [],
            airCrafts: [],
            acModels : []
        };
        var flightMasterList = [];
        self.flightList =  new rx.Subject();

        self.flightModesMasterList = function () {
            return [
                {
                    value:'VIP',
                    title: 'VIP'
                },{
                    value:'VVIP',
                    title: 'VVIP'
                }
            ]
        };

        self.saveManageFlight = function (selectedFlight, weekData, successFn, errorFn) {
            var requestParam = ManageFlightsRequestFactory.getSaveFlightRQ(selectedFlight, weekData);
            RemoteService.saveFlight(requestParam).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.getDefaultAircraftType = function () {
            self.data.airCrafts = [];
            self.data.airCrafts.push({model: "",modelNumber : ""});
            return self.data.airCrafts[0];
        };

        self.getDefaultLocation = function () {
            self.data.airports = [];
            return self.data.airports[0];
        };

        self.setAirports = function (locations) {
            var t = self.getDefaultLocation();
            self.data.airports = self.data.airports.concat(locations);
        };

        self.getAirports = function () {
            return self.data.airports;
        };

        self.setAirCrafts = function (airCrafts) {
            var t = self.getDefaultAircraftType();
            self.data.airCrafts = self.data.airCrafts.concat(airCrafts);
        };

        self.getAirCrafts = function () {
            return self.data.airCrafts;
        };

        self.setAcModels = function (acModels) {
            self.data.acModels = acModels;
        };

        self.getAcModels = function () {
            return self.data.acModels;
        };

        self.setSearchCriteria = function (params, successFn, errorFn) {
            var requestParam = ManageFlightsRequestFactory.searchFlightRQ(params);
            RemoteService.searchFlight(requestParam).then(
                function (response) {
                    if(response.success && response.hasOwnProperty('flightList')){
                        successFn(updateFlightList(response['flightList']));
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.setFlightList = function (flightList) {
            self.flightList.onNext(flightList || []);
        };

        self.getSelectedFlightForEditor = function (selectedFlight) {
           var flightEdit = ManageFlightsAdaptorFactory.adaptFlightForEditor(selectedFlight);
           if(!!selectedFlight){
        	   var capacities = _.filter (self.data.acModels, function(acModel) {
       		    return (acModel.capacity == selectedFlight.capacity);
       			});
        	   if(!!capacities && capacities.length > 0){
        		   flightEdit.acModelCapacity = capacities[0];
        	   }
           }
           return flightEdit;
        };

        self.getFlightInfoForEdit = function(selectedFlight){
            return ManageFlightsAdaptorFactory.adaptFlightForEdit(selectedFlight);
        };

        self.refineFlightData = function (refineParam) {
            var filter = {};
            if (!!refineParam.flightNumber.value && refineParam.flightNumber.value.trim() !== '' && refineParam.flightNumber.value !== 'ANY') {
                filter['flightNo'] = refineParam.flightNumber.value.trim();
            }
            if (!!refineParam.aircraftModel && refineParam.aircraftModel.modelNumber.trim() !== '' && refineParam.aircraftModel.modelNumber !== 'ANY') {
                filter['modelNo'] =  refineParam.aircraftModel.modelNumber.trim() ;
            }
            return _.filter(angular.copy(flightMasterList), filter);
        };

        function updateFlightList(searchResults) {
            flightMasterList =[];
            flightMasterList=flightMasterList.concat(searchResults || []);
            var temp =[];
            angular.forEach(searchResults, function (flight) {
                temp.push(ManageFlightsAdaptorFactory.adaptFlightResults(flight))
            });
            return temp
        }

    }
})();
